import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';
import { connect } from 'react-redux';

import { BackBtn } from '@comm/BackBtn';
import {
  queryDeleteFinanceBooks,
  queryFinanceBooksList,
  querySaveFinanceBooks,
} from '@api/finance/finance';

// import { getAccountInfo } from "../../../../store/modules/account_info";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      pageNo: 1,
      total: 0,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData();
    // this.props.dispatch(getAccountInfo());
  }

  loadData = pageNo => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = this.state.condition || '';
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryFinanceBooksList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          company: res.data.result,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 按条件搜索
   */
  search = () => {
    this.loadData();
  };

  delete = uuid => {
    const context = this;
    queryDeleteFinanceBooks(uuid).then(res => {
      if (res.statusCode === 200) {
        context.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 显示添加账户弹窗
   */
  showModalAdd = () => {};

  /**
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    this.uuid = uuid;
  };

  hideModal = () => {};

  /**
   * 新增账号
   */
  handAddSubmit = item => {
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 编辑账号
   */
  handEditSubmit = item => {
    item.uuid = this.uuid;
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  showApportion = () => {};

  columns = () => {
    return [
      {
        title: '预算类别',
        dataIndex: 'companyName',
        key: 'companyName',
      },
      {
        title: '预算（元）',
        dataIndex: 'bookName',
        key: 'bookName',
      },
    ];
  };

  render() {
    const { total, company, isLoading } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };

    return (
      <div>
        <div className="fixed-header">
          <Row type="flex" justify="space-between">
            <Col>
              <BackBtn />
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入关键字"
                style={{ width: '300px' }}
                value={this.state.condition}
                onChange={this.setCondition}
              />
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.search}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>
        <Table
          rowKey={record => record.uuid}
          columns={this.columns()}
          dataSource={company}
          pagination={pagination}
          loading={isLoading}
          style={{ paddingTop: '46px' }}
        />
      </div>
    );
  }
}

export default connect(state => ({ user: state.user }))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/budget/detail/PageDetail.js